export default __webpack_public_path__ + "static/media/Hair_8_M_C1.65c26b1d.svg";